/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.21.0
 */

import { ECookieKey } from '../../storage/storageTypes';
import { getCookieByName } from '../../storage/storageUtils';
import { ITableInitialise } from '../types';

export const getTableLoadSize = (list: ITableInitialise['list']) =>
    getCookieByName(ECookieKey.DENSITY_LIST_VIEW) === 'true' && !list?.disableCheckOnDensity ? 32 : 24
